import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsurancePlan, InsurancePlans } from 'src/app/models/database/insurance-plan.model';
import { PatientPlan } from 'src/app/models/database/patient-plan.model';
import { Id } from 'src/app/models/database/types/id.model';
import { HttpService } from '../http-service.service';

@Injectable({
  providedIn: 'root'
})
export class InsurancePlanService extends HttpService {

  constructor(private httpClient: HttpClient) {
    super('insurance-plan')
  }

  add(insuranceId: Id, insurancePlan: InsurancePlan): Observable<void> {
    return this.httpClient.post<void>(`${this.url}/insurance/${insuranceId}`, { insurancePlan })
  }

  getOne(insurancePlanId: Id): Observable<InsurancePlan> {
    return this.httpClient.get<InsurancePlan>(`${this.url}/${insurancePlanId}`)
  }

  getAllFromInsurance(insuranceId: Id, filter?: InsurancePlan): Observable<InsurancePlans> {
    let url: string = `${this.url}/insurance/${insuranceId}`
    if (filter) {
      url += this.implementQueries(filter)
    }
    return this.httpClient.get<InsurancePlans>(url)
  }

  edit(insurancePlanId: Id, insurancePlan: InsurancePlan): Observable<void> {
    return this.httpClient.put<void>(`${this.url}/${insurancePlanId}`, { insurancePlan })
  }

  delete(insurancePlanId: Id): Observable<void> {
    return this.httpClient.delete<void>(`${this.url}/${insurancePlanId}`)
  }
}
